export default __webpack_public_path__ + "static/media/uniswap-uni-logo.122b46d7.svg";